export async function loadPolyfillsAsync() {
  if (!Number.parseInt) {
    await Promise.all([
      import(/* webpackChunkName: "object-is-polyfill" */ './custom-polyfills/object-is'),
      import(/* webpackChunkName: "custom-event-polyfill" */ './custom-polyfills/custom-event')
    ])
    return
  }
  else {
    return 
  }
}

